import { DunningsModal } from "app/components/Dunnings/DunningsModal/DunningsModal";
import { ReactivateAccountModal } from "app/components/Dunnings/ReactivateAccountModal/ReactivateAccountModal";
import { RestartTrialDunningsModal } from "app/components/Dunnings/RestartTrialDunningsModal/RestartTrialDunningsModal";
import { useDunnings } from "app/components/hooks/useDunnings";

export const DunningsModals = () => {
    const { isInRetryProcess, isAfterTrialDunningsWithTrial, isAfterTrialDunningsWithoutTrial } = useDunnings();

    if (isInRetryProcess) {
        return <DunningsModal />;
    }

    if (isAfterTrialDunningsWithTrial) {
        return <RestartTrialDunningsModal />;
    }

    if (isAfterTrialDunningsWithoutTrial) {
        return <ReactivateAccountModal />;
    }

    return null;
};
